import { ChangeDetectorRef, Component, OnDestroy, OnInit, Inject
       } from '@angular/core';
import { PlaceholderService
       } from 'collage-designer/stage/placeholder/placeholder.service';
import { CropArea } from 'core/crop-area';
import { Utils } from 'core/utils';
import { Subscription } from 'rxjs';

@Component({
    selector: 'image-zoom',
    templateUrl: './image-zoom.component.html',
    styleUrls: ['./image-zoom.component.scss'],
    standalone: false
})

export class ImageZoomComponent implements OnInit, OnDestroy
{
  public readonly MAX_SCALE: number = CropArea.MAX_ZOOM;

  private static readonly ZOOM_STEP: number = 0.05;

  public scale: number = 1;

  private subscriptions: Subscription = new Subscription();

  constructor(
      private cdr: ChangeDetectorRef,
      @Inject(PlaceholderService) private placeholderService)
  {
  }

  public ngOnInit(): void
  {
    this.subscriptions.add(
        this.placeholderService.imageBeingEdited.subscribe(
            placeholder =>
                this.scale = placeholder.transformationManager.getScale()));
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
  }

  public zoomInputChanged(event: any): void
  {
    this.zoom(parseFloat(event.target.value) - this.scale);
  }

  private zoom(value: number): void
  {
    this.placeholderService.getFocusedPlaceholder()
      .callWithTransformationManager(m => {
        m.scale((m.getScale() + value) / m.getScale());

        this.scale = m.getScale();
        this.cdr.detectChanges();
      });
  }

  public decreaseZoomStep(): void
  {
    this.zoom(-ImageZoomComponent.ZOOM_STEP);
  }

  public increaseZoomStep(): void
  {
    this.zoom(ImageZoomComponent.ZOOM_STEP);
  }

  public showImageOverlay(): void
  {
    const focusedPh = this.placeholderService.getFocusedPlaceholder();
    focusedPh.showImageOverlay();
  }

  public hideImageOverlay(): void
  {
    const focusedPh = this.placeholderService.getFocusedPlaceholder();
    focusedPh.hideImageOverlay();
  }
}
